import request from 'superagent';

export default function markAsSeen(user, design) {
    request
        .post(design.links.markAsSeen)
        .set('X-Csrf-Token', user.tokens[0].mark_as_seen_design)
        .timeout(10000)
        .end();
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/actions/mark-as-seen.js